import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik } from 'formik'
import { SimpleInput } from 'components/Input'
import FormContext from './FormContext'
import * as FormElements from './FormElements'

export const FormContainer = styled.form.attrs(() => ({
  autocomplete: props => props.disableAutocomplete ? 'off' : undefined
}))``

class Form extends React.PureComponent {
  static propTypes = {
    ...Formik.propTypes,
    allowError: PropTypes.bool
  }

  static defaultProps = {
    ...Formik.defaultProps,
    allowError: false
  }

  handleSubmit = (formikProps, e, ...rest) => {
    if (!this.props.allowError &&
    Object.keys(formikProps.errors || {}).some(key => formikProps.errors[key])) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    formikProps.handleSubmit(e, ...rest)

    // in a situtation where nested Forms are existed and e.stopPropagation() is not being called,
    // the key press event will be bubbling up and consumed by the next (or following) nearest Form(s) which
    // may yield to unexpected behaviour
    e.stopPropagation()
  }

  renderForm = (formikProps) => {
    const { className, children, disableAutocomplete } = this.props
    return (
      <FormContext.Provider value={formikProps}>
        <FormContainer className={className} onSubmit={(...rest) => this.handleSubmit(formikProps, ...rest)} disableAutocomplete={disableAutocomplete}>
          {children}
        </FormContainer>
      </FormContext.Provider>
    )
  }

  render () {
    const { children, disableAutocomplete, className, initialValues, onValidate, onSubmit, disabled, ...props } = this.props
    return (
      <Formik
        {...props}
        render={this.renderForm}
        initialValues={initialValues}
        validate={onValidate}
        onSubmit={onSubmit} />
    )
  }
}

Form.Input = FormElements.FormInput
Form.SimpleInput = FormElements.FormSimpleInput
Form.SimpleInput.AddOn = SimpleInput.AddOn
Form.Password = FormElements.FormPassword
Form.NumberInput = FormElements.FormNumber
Form.TextArea = FormElements.FormTextArea
Form.Checkbox = FormElements.FormCheckbox
Form.RadioGroup = FormElements.FormRadioGroup
Form.Radio = FormElements.FormRadio
Form.SubmitButton = FormElements.SubmitButton
Form.DatePicker = FormElements.FormDatePicker
Form.SimpleDatePicker = FormElements.FormSimpleDatePicker
Form.DropdownDatePicker = FormElements.FormDropdownDatePicker
Form.QuantitySelector = FormElements.FormQuantitySelector
Form.Phone = FormElements.FormPhone
Form.AddressSearchInput = FormElements.FormAddressSearchInput
Form.Select = FormElements.FormSelect
Form.SelectWithLabel = FormElements.FormSelectWithLabel
Form.FieldError = FormElements.FormError
Form.ErrorMessage = FormElements.ErrorMessage
Form.Ref = FormElements.FormRef
Form.Effect = FormElements.Effect

export default Form
